import TicketComp from './TicketComp';
import MTicketComp from './MTicketComp';

export { TicketComp, MTicketComp };